import { useQuery } from '@tanstack/react-query';

import { trendingSearchesQueryOptions } from '../queries';
import type { SearchSuggestionOption } from '../types';

import type { SupportedLocation } from '@/modules/location/constants';

export function useTrendingSearches(
  location: SupportedLocation
): SearchSuggestionOption[] {
  const { data } = useQuery(trendingSearchesQueryOptions(location));

  return data ?? [];
}
